import { render, staticRenderFns } from "./ProductBanRow.vue?vue&type=template&id=56abfcf1"
import script from "./ProductBanRow.vue?vue&type=script&lang=js"
export * from "./ProductBanRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports